<template>
  <v-app>

    <v-main class="pa-0 app-main">

      <!-- =====================================================
           GEMEINSCHAFTSVERPFLEGUNG
      ====================================================== -->
      <section class="GemPflege">

        <div class="GemPflege-canvas">

          <!-- =================================================
               HERO-BEREICH
          ================================================== -->
          <div class="hero-content">

            <h1 class="page-title">
              Gemeinschafts<wbr>verpflegung
            </h1>

            <div class="heading-line"></div>

            <h3 class="hero-subtitle">
              Sichere Lösungen für eine verantwortungsvolle<br>
              und hygienische Verpflegung.
            </h3>

          </div>


          <!-- =================================================
               ZITATBOX
          ================================================== -->
          <div class="quote-box">

            <span class="quote-mark quote-left">
              “
            </span>

            <div class="quote-content">

              <div class="quote-title">
                Probleme gibt es genug.
              </div>

              <div class="quote-text">
                Uns geht es darum, Lösungen zu finden,
                die im Alltag funktionieren.
              </div>

              <div class="quote-line"></div>

            </div>

            <span class="quote-mark quote-right">
              ”
            </span>

          </div>


          <!-- =================================================
               HAUPTTEXT
          ================================================== -->
          <div class="content-text">

            <p>
              Wir begleiten Einrichtungen der Gemeinschaftsverpflegung dabei,
              mit Hygiene sicher umzugehen. Nicht theoretisch und nicht mit
              erhobenem Zeigefinger, sondern so, dass es im täglichen Betrieb
              umsetzbar bleibt.
            </p>

            <p>
              Gerade in Küchen, in denen viele Menschen versorgt werden,
              entsteht schnell Unsicherheit. Abläufe greifen ineinander,
              Verantwortung ist verteilt und Anforderungen kommen oft
              zusätzlich zum normalen Arbeitsalltag dazu.
            </p>

            <p>
              Viele arbeiten sauber und gewissenhaft
              und haben trotzdem ein ungutes Gefühl,
              wenn Kontrollen anstehen oder Entscheidungen getroffen werden müssen.
            </p>

            <p>
              Das hat meist wenig mit mangelnder Sorgfalt zu tun,
              sondern eher mit fehlender Klarheit im System.
            </p>


            <!-- =================================================
                 HERVORHEBUNG
            ================================================== -->
            <div class="highlight-section">

              <h2>
                Genau dort setzen wir an.
              </h2>

              <div class="small-line"></div>

            </div>


            <p>
              Wir bringen Struktur in Abläufe, schaffen Verständlichkeit
              und helfen dabei, Hygiene so umzusetzen,
              dass sie im Alltag trägt und nicht zusätzlich belastet.
            </p>

            <p>
              Unsere Arbeit basiert auf vielen Jahren Praxis in der
              Gemeinschaftsverpflegung und über 15 Jahren intensiver Arbeit
              im Thema Hygiene. Nicht aus dem Lehrbuch, sondern aus dem
              täglichen Betrieb.
            </p>

            <p>
              Wir gehen davon aus, dass sich Unsicherheiten klären lassen,
              wenn man sie offen anspricht und gemeinsam Lösungen entwickelt,
              die wirklich passen.
            </p>

            <p>
              Was es dafür braucht, ist die Bereitschaft, Dinge anzuschauen
              und sinnvoll zu verändern. Alles Weitere ergibt sich im
              gemeinsamen Arbeiten.
            </p>

          </div>

        </div>

      </section>

    </v-main>

  </v-app>
</template>


<script setup>

import GemPflege from '@/assets/GemPflege.png'

</script>


<style scoped>

/* ============================================================
   GRUNDLAYOUT
============================================================ */

:global(html),
:global(body),
:global(#app) {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  overflow-x: hidden;
}

:global(body) {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
}


/* ============================================================
   VUETIFY MAIN
============================================================ */

.app-main {
  width: 100% !important;
  min-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  background: #ffffff !important;
}


/* ============================================================
   HAUPTBEREICH
============================================================ */

.GemPflege {
  position: relative;

  width: 100%;

  margin: 0;

  padding: 0;

  background: #ffffff;

  color: #111111;

  overflow: hidden;

  box-sizing: border-box;
}


/* ============================================================
   DESKTOP CANVAS
============================================================ */

.GemPflege-canvas {
  position: relative;

  width: 100%;

  aspect-ratio: 1536 / 1024;

  margin: 0;

  padding: 0;

  overflow: hidden;

  background-color: #ffffff;

  background-image: v-bind(GemPflege);

  background-repeat: no-repeat;

  background-position: top center;

  background-size: 100% 100%;

  box-sizing: border-box;
}


/* ============================================================
   HERO
============================================================ */

.hero-content {
  position: absolute;

  left: 15.2%;

  top: 9%;

  width: 34%;
}


/* ============================================================
   HAUPTÜBERSCHRIFT
============================================================ */

.page-title {
  margin: 0;

  padding: 0;

  color: #17191d;

  font-size: clamp(
    30px,
    3.25vw,
    52px
  );

  line-height: 1.02;

  font-weight: 700;

  letter-spacing: -1.8px;
}


/* ============================================================
   GRÜNE TRENNLINIE
============================================================ */

.heading-line {
  width: 46px;

  height: 3px;

  margin-top: 15px;

  margin-bottom: 14px;

  background: #72b82a;

  border-radius: 2px;
}


/* ============================================================
   HERO H3
============================================================ */

.hero-subtitle {
  margin: 0;

  padding: 0;

  color: #17191d;

  font-size: clamp(
    11px,
    0.92vw,
    15px
  );

  line-height: 1.45;

  font-weight: 700;

  letter-spacing: -0.2px;
}


/* ============================================================
   ZITATBOX
============================================================ */

.quote-box {
  position: absolute;

  left: 20.65%;

  top: 32.55%;

  width: 58.75%;

  height: 9.25%;

  display: flex;

  align-items: center;

  justify-content: center;

  box-sizing: border-box;

  padding: 0 5%;

  background: rgba(
    247,
    251,
    242,
    0.94
  );

  border: 1px solid rgba(
    114,
    184,
    42,
    0.16
  );

  border-radius: 11px;

  box-shadow:
    0 5px 20px rgba(
      0,
      0,
      0,
      0.025
    );
}


/* ============================================================
   ZITATZEICHEN
============================================================ */

.quote-mark {
  position: absolute;

  color: #72b82a;

  font-family:
    Georgia,
    "Times New Roman",
    serif;

  font-size: clamp(
    40px,
    4vw,
    65px
  );

  line-height: 1;

  font-weight: 700;
}

.quote-left {
  left: 3%;
  top: 15%;
}

.quote-right {
  right: 3%;
  bottom: -4%;
}


/* ============================================================
   ZITAT-INHALT
============================================================ */

.quote-content {
  width: 100%;

  text-align: center;
}

.quote-title {
  color: #17191d;

  font-size: clamp(
    14px,
    1.35vw,
    21px
  );

  line-height: 1.15;

  font-weight: 700;
}

.quote-text {
  margin-top: 4px;

  color: #17191d;

  font-size: clamp(
    12px,
    1.15vw,
    18px
  );

  line-height: 1.2;

  font-weight: 700;
}

.quote-line {
  width: 38px;

  height: 3px;

  margin:
    8px
    auto
    0;

  background: #72b82a;

  border-radius: 2px;
}


/* ============================================================
   HAUPTTEXT
============================================================ */

.content-text {
  position: absolute;

  left: 31.5%;

  top: 44.1%;

  width: 44.5%;

  color: #22252a;

  font-size: clamp(
    10px,
    0.84vw,
    13px
  );

  line-height: 1.42;
}


/* ============================================================
   ABSÄTZE
============================================================ */

.content-text p {
  margin:
    0
    0
    11px;

  padding: 0;

  color: #22252a;

  font-size: inherit;

  line-height: 1.42;

  font-weight: 400;
}


/* ============================================================
   HIGHLIGHT
============================================================ */

.highlight-section {
  margin-top: 24px;

  margin-bottom: 12px;
}

.highlight-section h2 {
  margin: 0;

  padding: 0;

  color: #17191d;

  font-size: clamp(
    14px,
    1.22vw,
    19px
  );

  line-height: 1.2;

  font-weight: 700;

  letter-spacing: -0.25px;
}


/* ============================================================
   KLEINE GRÜNE LINIE
============================================================ */

.small-line {
  width: 32px;

  height: 2px;

  margin-top: 8px;

  background: #72b82a;

  border-radius: 2px;
}


/* ============================================================
   GROSSE DESKTOP-BILDSCHIRME
============================================================ */

@media (min-width: 1600px) {

  .page-title {
    font-size: 52px;
  }

  .hero-subtitle {
    font-size: 15px;
    font-weight: 700;
  }

  .quote-title {
    font-size: 21px;
  }

  .quote-text {
    font-size: 18px;
  }

  .content-text {
    font-size: 13px;
  }

  .highlight-section h2 {
    font-size: 19px;
  }

}


/* ============================================================
   TABLET
============================================================ */

@media (max-width: 1100px) and (min-width: 761px) {

  .page-title {
    font-size: 39px;
    letter-spacing: -1.2px;
  }

  .heading-line {
    width: 38px;
    height: 2px;
    margin-top: 11px;
    margin-bottom: 10px;
  }

  .hero-subtitle {
    font-size: 11px;
    font-weight: 700;
  }

  .quote-title {
    font-size: 16px;
  }

  .quote-text {
    font-size: 14px;
  }

  .content-text {
    font-size: 10px;
    line-height: 1.4;
  }

  .content-text p {
    font-size: 10px;
    line-height: 1.4;
    margin-bottom: 8px;
  }

  .highlight-section {
    margin-top: 17px;
  }

  .highlight-section h2 {
    font-size: 15px;
  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 760px) {

  .GemPflege {
    width: 100%;

    min-height: 0 !important;

    height: auto;

    overflow: visible;

    background: #ffffff !important;
  }


  /* ========================================================
     MOBILE CANVAS
  ========================================================= */

  .GemPflege-canvas {
    width: 100%;

    height: auto;

    min-height: 0 !important;

    aspect-ratio: auto;

    overflow: visible;

    background-color: #ffffff;

    background-image: none;

    box-sizing: border-box;
  }


  /* ========================================================
     MOBILE HERO
  ========================================================= */

  .hero-content {
    position: relative;

    left: auto;

    top: auto;

    width: 100%;

    height: 350px;

    min-height: 350px;

    box-sizing: border-box;

    padding:
      30px
      24px
      35px;

    background-image: v-bind(GemPflege);

    background-repeat: no-repeat;

    background-size: auto 100%;

    background-position: 68% top;

    background-color: #ffffff;

    border-radius: 0;
  }


  /* ========================================================
     MOBILE HAUPTÜBERSCHRIFT
  ========================================================= */

  .page-title {
    position: relative;

    z-index: 2;

    max-width: 340px;

    margin: 0;

    font-size: 34px;

    line-height: 1.03;

    letter-spacing: -1px;
  }


  /* ========================================================
     MOBILE GRÜNE LINIE
  ========================================================= */

  .heading-line {
    position: relative;

    z-index: 2;

    width: 36px;

    height: 2px;

    margin-top: 12px;

    margin-bottom: 13px;
  }


  /* ========================================================
     MOBILE H3
  ========================================================= */

  .hero-subtitle {
    position: relative;

    z-index: 2;

    max-width: 340px;

    margin: 0;

    font-size: 12px;

    line-height: 1.48;

    font-weight: 700;
  }


  /* ========================================================
     MOBILE ZITATBOX
  ========================================================= */

  .quote-box {
    position: relative;

    left: auto;

    top: auto;

    z-index: 5;

    width: calc(100% - 30px);

    min-height: 0;

    height: auto;

    margin:
      -1px
      auto
      0;

    padding:
      17px
      42px
      15px;

    display: flex;

    align-items: center;

    justify-content: center;

    box-sizing: border-box;

    background: rgba(
      247,
      251,
      242,
      0.96
    );

    border: 1px solid rgba(
      114,
      184,
      42,
      0.16
    );

    border-radius: 12px;

    box-shadow:
      0 5px 18px rgba(
        0,
        0,
        0,
        0.04
      );
  }


  /* ========================================================
     MOBILE ZITATZEICHEN
  ========================================================= */

  .quote-mark {
    font-size: 48px;

    line-height: 1;

    color: #72b82a;
  }

  .quote-left {
    left: 10px;

    top: 8px;
  }

  .quote-right {
    right: 10px;

    bottom: -2px;
  }


  /* ========================================================
     MOBILE ZITAT-INHALT
  ========================================================= */

  .quote-content {
    width: 100%;

    text-align: center;
  }

  .quote-title {
    font-size: 16px;

    line-height: 1.25;

    font-weight: 700;
  }

  .quote-text {
    margin-top: 4px;

    font-size: 13px;

    line-height: 1.35;

    font-weight: 700;
  }

  .quote-line {
    width: 30px;

    height: 2px;

    margin:
      9px
      auto
      0;
  }


  /* ========================================================
     MOBILE HAUPTTEXT

     WICHTIGE ÄNDERUNG:
     Der komplette P-Bereich wird deutlich weiter
     unter die Zitatbox geschoben.
  ========================================================= */

  .content-text {
    position: relative;

    left: auto;

    top: auto;

    width: calc(100% - 40px);

    /*
     * vorher: 34px
     * jetzt: 60px
     */
    margin:
      60px
      auto
      0;

    padding:
      0
      0
      55px;

    color: #22252a;

    font-size: 12px;

    line-height: 1.52;

    background: #ffffff;
  }


  /* ========================================================
     ERSTER P-TAG
  ========================================================= */

  .content-text > p:first-child {
    margin-top: 0;

    padding-top: 0;
  }


  /* ========================================================
     MOBILE ABSÄTZE
  ========================================================= */

  .content-text p {
    margin:
      0
      0
      14px;

    padding: 0;

    color: #22252a;

    font-size: 12px;

    line-height: 1.52;
  }


  /* ========================================================
     MOBILE HIGHLIGHT
  ========================================================= */

  .highlight-section {
    margin-top: 25px;

    margin-bottom: 14px;
  }

  .highlight-section h2 {
    margin: 0;

    font-size: 17px;

    line-height: 1.2;

    color: #17191d;
  }

  .small-line {
    width: 28px;

    height: 2px;

    margin-top: 7px;
  }

}


/* ============================================================
   KLEINE SMARTPHONES
============================================================ */

@media (max-width: 480px) {

  .hero-content {
    width: 100%;

    height: 335px;

    min-height: 335px;

    padding:
      27px
      20px
      30px;

    background-size: auto 100%;

    background-position: 70% top;
  }


  .page-title {
    max-width: 300px;

    font-size: 29px;

    line-height: 1.04;

    letter-spacing: -0.8px;
  }


  .heading-line {
    width: 34px;

    height: 2px;

    margin-top: 10px;

    margin-bottom: 11px;
  }


  .hero-subtitle {
    max-width: 300px;

    font-size: 11px;

    line-height: 1.5;

    font-weight: 700;
  }


  /* ========================================================
     ZITATBOX
  ========================================================= */

  .quote-box {
    width: calc(100% - 24px);

    margin-top: 0;

    padding:
      15px
      34px
      14px;

    border-radius: 11px;
  }


  .quote-mark {
    font-size: 42px;
  }

  .quote-left {
    left: 8px;

    top: 8px;
  }

  .quote-right {
    right: 8px;

    bottom: -2px;
  }

  .quote-title {
    font-size: 14px;

    line-height: 1.25;
  }

  .quote-text {
    font-size: 11.5px;

    line-height: 1.38;
  }

  .quote-line {
    width: 28px;

    height: 2px;

    margin-top: 8px;
  }


  /* ========================================================
     HAUPTTEXT

     Auch hier bewusst mehr Abstand zur Zitatbox.
  ========================================================= */

  .content-text {
    width: calc(100% - 30px);

    /*
     * vorher: 32px
     * jetzt: 55px
     */
    margin-top: 55px;

    padding-bottom: 50px;

    font-size: 11px;

    line-height: 1.5;

    background: #ffffff;
  }


  .content-text p {
    margin-bottom: 12px;

    font-size: 11px;

    line-height: 1.5;
  }


  .highlight-section {
    margin-top: 21px;

    margin-bottom: 13px;
  }


  .highlight-section h2 {
    font-size: 15px;
  }

}


/* ============================================================
   SEHR KLEINE SMARTPHONES
============================================================ */

@media (max-width: 360px) {

  .hero-content {
    height: 315px;

    min-height: 315px;

    padding:
      24px
      17px
      28px;

    background-size: auto 100%;

    background-position: 73% top;
  }


  .page-title {
    font-size: 26px;

    letter-spacing: -0.7px;
  }


  .hero-subtitle {
    font-size: 10px;

    line-height: 1.48;

    font-weight: 700;
  }


  .quote-box {
    width: calc(100% - 20px);

    padding:
      14px
      30px
      13px;
  }


  .quote-mark {
    font-size: 38px;
  }


  .quote-title {
    font-size: 12.5px;
  }


  .quote-text {
    font-size: 10.5px;
  }


  /* ========================================================
     HAUPTTEXT NOCH ETWAS WEITER NACH UNTEN
  ========================================================= */

  .content-text {
    width: calc(100% - 26px);

    margin-top: 50px;

    padding-bottom: 45px;
  }


  .content-text p {
    font-size: 10.5px;

    line-height: 1.48;
  }


  .highlight-section h2 {
    font-size: 14px;
  }

}


/* ============================================================
   KEIN SCHWARZER BEREICH VOR DEM FOOTER
============================================================ */

.GemPflege::after {
  content: "";

  display: block;

  width: 100%;

  height: 0;

  background: #ffffff;
}


@media (max-width: 760px) {

  .GemPflege::after {
    height: 1px;

    background: #ffffff;
  }

}

</style>